import service from '@/services/modules/seguridad/usuario'

export default {
  USUARIO_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      service.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_ALL_SALES(_, params) {
    return new Promise((resolve, reject) => {
      service.findAllSales(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  USUARIO_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      service.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      service.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_RESET_PASSWORD(_, params) {
    return new Promise((resolve, reject) => {
      service.resetPassword(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      service.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
